import { PROPERTY_GRID_SUBJECT_PROPERTY, schQueryParams } from '@aloft/toolkit-shared';
import { Button, Tooltip, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/prefer-sound-ui-box, aloft/no-sui-chakra
import { Box } from '@aloft/toolkit-sui/chakra';

import { useEffect } from 'react';

import { useAddCompModals } from '../hooks/useAddCompModals.tsx';
import { selectIsInspectifyOrder } from '../redux/features/selectors/orderSelectors.ts';
import { selectEditablePropertyDataById } from '../redux/features/selectors/propertyDataSelectors/editablePropertyDataSelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { GuidedTourTooltip } from './GuidedTour/GuidedTourTooltip.tsx';

export const AddCompButtons = () => {
  const {
    addCompsModal,
    addRecommendedCompsModal,
    openAddCompsModal,
    openAddRecommendedCompsModal,
  } = useAddCompModals();

  const isInspectifyOrder = useAppSelector(selectIsInspectifyOrder);

  const subjectEditableData = useAppSelector((state) =>
    selectEditablePropertyDataById(state, PROPERTY_GRID_SUBJECT_PROPERTY),
  );
  const showRecComps = useAppSelector(
    (state) =>
      state.order.propertyType &&
      ['singleFamilyResidence', 'townhouse'].includes(state.order.propertyType),
  );

  const gla = subjectEditableData?.improvements?.gla;
  const siteArea = subjectEditableData?.site?.area;
  const isRecCompsDisabled = !subjectEditableData || !gla || !siteArea || siteArea.unitAmount === 0;

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    if (
      params.get(schQueryParams.enum.addComps) === 'true' ||
      params.get(schQueryParams.enum.filters) === 'true'
    ) {
      openAddRecommendedCompsModal();
    }
  }, [openAddRecommendedCompsModal]);

  if (!isInspectifyOrder) {
    return (
      <>
        {addCompsModal}
        <GuidedTourTooltip
          text={[
            'Click `Add Comps` to manually add comparable properties for this order.',
            'If you created your order by uploading an appraisal XML, Toolkit automatically brings in comps from that report.',
          ]}
          tourID="analysisTour"
          tourIndex={0}
          placement="left"
        >
          <Box>
            <Button variant="primary" size="sm" text="Add Comps" onClick={openAddCompsModal} />
          </Box>
        </GuidedTourTooltip>
      </>
    );
  }

  if (!showRecComps) return null;

  return (
    <>
      {addRecommendedCompsModal}
      <GuidedTourTooltip
        text={[
          'Click `Add Comps` to browse and select recommended comps for this property.',
          'If you created your order by uploading an appraisal XML, Toolkit automatically brings in comps from that report.',
        ]}
        tourID="analysisTour"
        tourIndex={0}
        placement="left"
      >
        <Tooltip
          label={
            isRecCompsDisabled ? (
              <Typography variant="body2">
                Please enter subject property&apos;s GLA and Lot Size to enable this feature.
              </Typography>
            ) : undefined
          }
          isDisabled={!isRecCompsDisabled}
          placement="bottom"
        >
          <Box>
            <Button
              variant="primary"
              size="sm"
              text="Add Comps"
              disabled={isRecCompsDisabled}
              onClick={isRecCompsDisabled ? () => {} : openAddRecommendedCompsModal}
            />
          </Box>
        </Tooltip>
      </GuidedTourTooltip>
    </>
  );
};
